import { IGroupsHasUsers } from '@llws/platform-shared-types/types/db/auth';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath = '/perms-api/groups__has_users';

const base = new StoreBaseImplementationV2<Partial<IGroupsHasUsers>>({
  adminGatewayResourcePath,
});

export default {
  namespaced: true,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,

  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
